import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRipplingLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 630 630",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 630,
			height: 630,
			fill: "url(#paint0_linear_58_9153)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_58_9153)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M329.444 328.382C342.326 334.661 350.755 344.518 354.551 357.645C356.921 365.762 358.297 374.135 358.65 382.582C359.268 399.651 358.773 416.758 358.913 433.85C358.913 437.059 357.954 437.985 354.753 437.954C339.288 437.807 323.823 437.761 308.358 437.992C304.538 438.054 303.842 436.558 303.865 433.272C303.974 416.432 303.992 399.597 303.919 382.767C303.803 362.713 296.249 346.307 279.338 334.792C275.967 332.478 272.294 330.657 268.288 328.328C291.13 311.236 307.306 290.488 307.376 260.8C307.445 231.113 291.47 210.288 268.799 193.265L269.286 192.416C270.608 192.316 271.93 192.139 273.245 192.139C289.483 192.139 305.721 192.301 321.959 192C326.769 191.915 330.217 193.543 333.558 196.628C371.826 231.876 371.609 290.01 333.024 324.988C331.926 326.03 330.836 327.071 329.444 328.382Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M152.193 328.444C175.174 311.182 191.389 290.442 191.428 260.777C191.466 231.113 175.561 210.249 151.992 192.617C154.374 192.363 155.425 192.147 156.485 192.147C174.007 192.147 191.521 192.039 209.065 192.208C211.198 192.317 213.24 193.101 214.896 194.445C256.056 228.822 256.651 290.473 216.326 325.698C215.468 326.469 214.641 327.241 213.496 328.29C222.773 332.724 230.367 340.028 235.147 349.115C240.738 359.558 242.671 370.92 242.802 382.582C243.003 399.666 242.802 416.758 242.949 433.843C242.949 437.036 241.975 438.016 238.766 437.992C223.053 437.854 207.331 437.854 191.598 437.992C188.505 437.992 188.01 436.835 188.002 434.136C188.002 415.625 188.211 397.113 187.585 378.648C186.812 356.882 176.063 341.101 156.841 330.951C155.541 330.241 154.211 329.524 152.193 328.444Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M385.481 192.301C386.726 192.239 387.971 192.123 389.216 192.123C405.709 192.123 422.203 192.262 438.704 192.031C442.786 191.969 445.733 193.288 448.679 195.887C488.114 230.712 487.743 291.529 447.797 326.037C447.024 326.701 446.251 327.356 445.153 328.297C458.298 334.36 466.703 344.495 470.616 357.846C472.906 365.723 474.204 373.853 474.482 382.05C475.062 399.018 474.59 415.987 474.737 432.956C474.737 436.727 473.732 438.039 469.711 437.969C454.509 437.715 439.307 437.776 424.089 437.969C420.811 437.969 419.883 436.897 419.898 433.773C419.976 416.681 419.953 399.589 419.829 382.497C419.628 358.386 408.779 340.846 387.059 330.048C386.285 329.663 385.512 329.153 384.739 328.644C390.152 323.693 395.711 319.134 400.706 314.036C415.344 299.088 423.594 281.279 423.417 260.122C423.216 236.373 412.591 217.499 395.263 201.958C391.953 198.988 388.52 196.15 385.149 193.257L385.481 192.301Z",
					fill: "black"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_58_9153",
			x1: 630,
			y1: 26,
			x2: 187457e-10,
			y2: 591,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFC700" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF9F00"
			})]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_58_9153",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 326,
				height: 246,
				fill: "white",
				transform: "translate(152 192)"
			})
		})] })
	]
});
export { SvgRipplingLogo as ReactComponent };
